import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KEY_CODE } from '../memory-experiment.component';

@Component({
  selector: 'app-categorisation',
  templateUrl: './categorisation.component.html',
  styleUrls: ['./categorisation.component.css']
})
export class CategorisationComponent implements OnInit {

  @Input() task: String //manmade OR alive
  @Input() demo: boolean //true --> demo, false --> actual test
  @Input() demoData: Array<any>
  @Input() liveData: Array<any>
  @Input() round: number
  @Input() started: boolean
  @Input() ready: boolean
  @Input() startFunction: Function
  @Input() submitTask: Function
  @Input() timestamp: Function
  @Input() checkRound: Function
  @Input() currentAnswers: any[]
  @Input() updateCorrectness: Function
  @Input() overview: boolean
  @Input() dialogOpen: boolean //if true keyboard inputs are disabled
  @Input() updateCorrectAnswersCount : Function
  @Input() getReady: boolean

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {

  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if (this.started) {

      let validKey = false
      let response;

      if (!this.dialogOpen && event.key === KEY_CODE.RIGHT_ARROW) {

        validKey = true
        response = false
      }
      else if (!this.dialogOpen && event.key === KEY_CODE.LEFT_ARROW) {
        validKey = true
        response = true
      }
      if (validKey) {

        //correct answer, used to give feedback
        let correctAns: boolean

        if (!this.demo) {

          this.currentAnswers.push({
            "task": this.task + '_task',
            "id": this.liveData[this.round].id,
            "timestamp": this.timestamp(),
            "choice": response
          })
          correctAns = this.liveData[this.round].correctResponse === 'YES' ? true : false
          if(response === correctAns)
            this.updateCorrectAnswersCount()
        }
        else {
          correctAns = this.demoData[this.round].correctResponse === 'YES' ? true : false
          this.updateCorrectness(response === correctAns)
        }
        this.checkRound('categorisation')
      }

    }
  }
}
